var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.564,
    height: 13.85,
    viewBox: "0 0 14.564 13.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(-1280.436 -243.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M-2663.44,1794.662l-.1,0h-7.262a3.741,3.741,0,0,1-2.869-1.04,2.878,2.878,0,0,1-.749-2,70.629,70.629,0,0,1,0-7.57,3.352,3.352,0,0,1,1.849-2.792,4.125,4.125,0,0,1,1.578-.444h1.74v1.42h-1.685a2.808,2.808,0,0,0-1.021.307,1.949,1.949,0,0,0-1.048,1.648,71.9,71.9,0,0,0,0,7.4l0,.053,0,.032a1.461,1.461,0,0,0,.383,1,2.436,2.436,0,0,0,1.816.572l7.328,0a2.11,2.11,0,0,0,1.4-.493,2.452,2.452,0,0,0,.662-1.8c0-.087.032-.716.032-.716l1.418.076s-.029.545-.03.62v.042a3.8,3.8,0,0,1-1.14,2.837A3.529,3.529,0,0,1-2663.44,1794.662Z",
    transform: "translate(3954.964 -1537.049)",
    fill: "#337dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M0,9.44,8.02,1.42H3.356V0h7.088V7.057H9.024V2.425L1,10.444Z",
    transform: "translate(1284.556 243.763)",
    fill: "#337dff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOpen);
export default __webpack_public_path__ + "static/media/link-open.5cad1e2dd9dab0e1fa6a038cee40df3e.svg";
export { ForwardRef as ReactComponent };